<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M7.49984 5.73503L1.6665 2.81836V13.8484L7.49984 16.765L12.4998 14.265L18.3332 17.1817V6.15169L12.4998 3.23503L7.49984 5.73503ZM12.4998 12.5L7.49984 15V7.50003L12.4998 5.00003V12.5Z"
            fill="currentColor"
        />
    </svg>
</template>
